import React from "react";
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import CircularProgress from '@material-ui/core/CircularProgress'
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useHistory,useLocation } from "react-router-dom";
import { connect } from 'react-redux';
import axios from 'axios';

import { Button, Card, CardHeader, CardBody, FormGroup, Form, Input, InputGroupAddon, InputGroupText, InputGroup, Row, Col,} from "reactstrap";


const Login = (props) => {
    const [sendingdata, setSendingdata] = React.useState('');
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    // console.log(props.code)
    const history = useHistory();
    const location = useLocation();

    if (location) {
        // console.log('yes location')
        // console.log(location);
        // console.log(location.state);
        if (location.state != null) {
            if (location.state.token) {
                if (location.state.token === 1) {
                    // console.log(location.state.message);
                    setSendingdata(location.state.message);
                    settt(location.state.type);
                    setOpen(true);
                    location.state.token -= 1;
                }
            }
        }
    }
    const [show, setShow] = React.useState(false);
    const [show2, setShow2] = React.useState(false);
    const [showpass1, setShowPass1] = React.useState(false);
    const [showpass2, setShowPass2] = React.useState(false);
    const [showpass3, setShowPass3] = React.useState(false);
    const [showpass4, setShowPass4] = React.useState(false);
    const [loading, setloading] = React.useState('Signup');
    const [disabling, setdisabling] = React.useState(false);
    const [code, setCode] = React.useState();
    const [code2, setCode2] = React.useState();

    const [details, setDetails] = React.useState({ 'utype': 'buyer', 'code': Math.floor((Math.random() * 999999) + 100000).toString()});

    const handleClose = (event, reason) => {
        setOpen(false);
    };
    const handleChange = (event) => {
        setDetails({...details, [event.target.name]: event.target.value})
    };
    const handleChangeA = (event) => {
        if (event.target.value === 'depact2021@kjsTeachers') {
            event.target.style.backgroundColor = 'lightgreen';
            event.target.style.color = 'black';
            setCode('right')
        }
        else {
            event.target.style.backgroundColor = '';
            setCode('wrong');
        }
        setDetails({ ...details, [event.target.name]: event.target.value })
    };
    const handleChangeA2 = (event) => {
        if (event.target.value === 'KjsieitAdminTeachers@depact2021') {
            event.target.style.backgroundColor = 'lightgreen';
            event.target.style.color = 'black';
            setCode2('right')
        }
        else {
            event.target.style.backgroundColor = '';
            setCode2('wrong');
        }
        setDetails({ ...details, [event.target.name]: event.target.value })
    };
    const handleChangeS = (event) => {
        if (event.target.value === 'vendor') {
            setShow(true)
            setShow2(false)
        }
        else if (event.target.value === 'admin') {
            setShow2(true)
            setShow(false)
        }
        else {
            setShow(false)
            setShow2(false)
        }
        setDetails({...details,utype: event.target.value})
    };
    const handleClickShowPassword1 = () => {
        if (showpass1 === false) {
            setShowPass1(true);
        }
        else {
            setShowPass1(false)
        }
    };
    const handleClickShowPassword2 = () => {
        if (showpass2 === false) {
            setShowPass2(true);
        }
        else {
            setShowPass2(false)
        }
    };
    const handleClickShowPassword3 = () => {
        if (showpass3 === false) {
            setShowPass3(true);
        }
        else {
            setShowPass3(false)
        }
    };
    const handleClickShowPassword4 = () => {
        if (showpass4 === false) {
            setShowPass4(true);
        }
        else {
            setShowPass4(false)
        }
    };

    const loginPageHandler = () => {
        // console.log(details)
        setloading(<CircularProgress size="20px" style={{ color: '#172b4d' }} />)
        setdisabling(true)
        if ((details.username === undefined) || (details.password === undefined) || (details.email === undefined) || (details.firstname === undefined) || (details.lastname === undefined)) {
            setSendingdata('Please Enter all the Credentials properly')
            settt('error');
            setOpen(true);
            setloading('Signup')
            setdisabling(false)
            return 0;
        }
        if ((details.username.length < 1) || (details.password.length < 1) || (details.email.length < 1) || (details.firstname.length < 1) || (details.lastname.length < 1)) {
            setSendingdata('Please Enter all the Credentials properly')
            settt('error');
            setOpen(true);
            setloading('Signup')
            setdisabling(false)
            return 0;
        }
        if (details.department === undefined) {
            setSendingdata('Please Select Department')
            settt('error');
            setOpen(true);
            setloading('Signup')
            setdisabling(false)
            return 0;
        }
        if (details.contact === undefined) {
            setSendingdata('Please Add your Contact Info')
            settt('error');
            setOpen(true);
            setloading('Signup')
            setdisabling(false)
            return 0;
        }
        if (details.password === details.password2) {
            // console.log('good');
        }
        else {
            setSendingdata('Passwords do not match')
            settt('error');
            setOpen(true);
            setloading('Signup')
            setdisabling(false)
            return 0;
        }
        if (details.utype === 'vendor') {
            if (code === 'right') {
                // console.log('right');
            }
            else {
                setSendingdata('Entered Faculty Code is Wrong')
                settt('error');
                setOpen(true);
                setloading('Signup')
                setdisabling(false)
                return 0;
            }
        }
        if (details.utype === 'admin') {
            if (code2 === 'right') {
                // console.log('right');
            }
            else {
                setSendingdata('Entered Super-Admin Code is Wrong')
                settt('error');
                setOpen(true);
                setloading('Signup')
                setdisabling(false)
                return 0;
            }
        }
        setSendingdata('Please wait a sec')
        settt('success');
        setOpen(true);
        // console.log(details)
        axios.post(process.env.REACT_APP_DOMAIN+'/signup', details)
            .then((response) => {
                setloading('Signup')
                setdisabling(false)
                if(response.data.status === 201){
                    history.push({
                        pathname: '/auth/details',
                        state: response.data
                    })
                }
                else {
                    setSendingdata(response.data.message)
                    settt('error');
                    setOpen(true)
                    setloading('Signup')
                    setdisabling(false)
                }
                
            })
            .catch((error) => {
                setSendingdata('Something went wrong, please add details properly')
                settt('error');
                setOpen(true)
                setloading('Signup')
                setdisabling(false)
            })
    };
    return (
        <>
            <Col>
                <Card className="bg-secondary shadow border-0">
                    <CardHeader className="bg-transparent pb-5">
                        <div className="btn-wrapper text-center">
                            <Button
                                className="btn-neutral btn-icon"
                                color="default"
                                href="#pablo"
                                onClick={(e) => e.preventDefault()}
                            >
                                <span className="btn-inner--icon">
                                    <img
                                        alt="..."
                                        src={
                                            require("../../assets/img/kj.png")
                                                .default
                                        }
                                    />
                                </span>
                                <span className="btn-inner--text">Signup Page</span>
                            </Button>
                        </div>
                    </CardHeader>
                    <CardBody className="px-lg-12 py-lg-5">
                        <Form role="form">
                            <Row className="row">
                            <Col className="" sm={12} lg={6}>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="ni ni-circle-08" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Username" style={{backgroundColor: 'white'}} type="text" autoComplete="" onChange={handleChange} name="username"/>
                                </InputGroup>
                            </FormGroup>
                            </Col>
                                <Col className="" sm={12} lg={6}>
                            <FormGroup className="mb-3">
                                <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                        <InputGroupText>
                                            <i className="ni ni-email-83" />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                    <Input placeholder="Email" type="email" onChange={handleChange} name="email"/>
                                </InputGroup>
                            </FormGroup>
                            </Col>
                            </Row>
                            <Row className="row">
                                <Col className="" sm={12} lg={6}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-single-02" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder="First Name" type="text" autoComplete="" onChange={handleChange} name="firstname"/>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col className="" sm={12} lg={6}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-single-02" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder="Last Name" type="text" autoComplete="" onChange={handleChange} name="lastname"/>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="row">
                                <Col className="" sm={12} lg={6}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative" style={{ backgroundColor: 'white' }}>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-lock-circle-open" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder="Password" type={showpass1 ? "text" : "password"} onChange={handleChange} name="password" style={{ marginTop: '2px' }}/>
                                            <InputGroupAddon addonType="append" style={{ backgroundColor: 'white' }}>
                                                <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword1} style={{ color: '#acb5bc', padding: '0px 10px',  backgroundColor: 'transparent' }} disableRipple>
                                                    {showpass1 ? <Visibility style={{ width: 18 }} /> : <VisibilityOff style={{ width: 18 }} />}
                                                </IconButton>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col className="" sm={12} lg={6}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative" style={{ backgroundColor: 'white' }}>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-lock-circle-open" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder="Re-enter Password" type={showpass2 ? "text" : "password"} onChange={handleChange} name="password2" style={{ marginTop: '2px' }}/>
                                            <InputGroupAddon addonType="append" style={{backgroundColor: 'white'}}>
                                                <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword2} style={{ color: '#acb5bc', padding: '0px 10px',  backgroundColor: 'transparent' }} disableRipple>
                                                    {showpass2 ? <Visibility style={{ width: 18 }} /> : <VisibilityOff style={{ width: 18 }} />}
                                                </IconButton>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="row">
                                <Col className="" sm={12} lg={6}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-tag" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder="Department" type="select" autoComplete="" name="department" onChange={handleChange}>
                                                <option value="buyer">--Select Department --</option>
                                                <option value="COMPS">COMPS</option>
                                                <option value="IT">IT</option>
                                                <option value="EXTC">EXTC</option>
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                <Col className="" sm={12} lg={6}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-mobile-button" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder="Contact Info" type="text" onChange={handleChange} name="contact"/>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="row">
                                <Col className="" sm={12} lg={6}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText><i className="ni ni-badge" /></InputGroupText>
                                            </InputGroupAddon>
                                            <Input placeholder="Type" type="select" autoComplete=""  onChange={handleChangeS}>
                                                <option value="buyer">Student</option>
                                                <option value="vendor">Faculty</option>
                                                <option value="admin">Super-Admin</option>
                                            </Input>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                {show && 
                                <Col className="" sm={12} lg={6}>
                                    <FormGroup className="mb-3">
                                        <InputGroup className="input-group-alternative" style={{ backgroundColor: '' }}>
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText style={{ backgroundColor: (code === 'right' ? 'lightgreen' : 'white'), color: (code === 'right' ? 'black' : '') }}><i className="ni ni-key-25" /></InputGroupText>
                                            </InputGroupAddon>
                                            <Input style={{ backgroundColor: (code === 'right' ? 'lightgreen' : 'white'),color: (code === 'right' ? 'black' : '#acb5bc') }} value={details.adcode} placeholder="Faculty Code" type={showpass3 ? "text" : "password"} name="adcode" onChange={handleChangeA} />
                                            <InputGroupAddon addonType="append" style={{ backgroundColor: (code === 'right' ? 'lightgreen' : 'white')  }}>
                                                <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword3} style={{ color: (code === 'right' ? 'black' : '#acb5bc'), padding: '0px 10px', backgroundColor: 'transparent'}} disableRipple>
                                                    {showpass3 ? <Visibility style={{ width: 18 }} /> : <VisibilityOff style={{ width: 18 }} />}
                                                </IconButton>
                                            </InputGroupAddon>
                                        </InputGroup>
                                    </FormGroup>
                                </Col>
                                }
                                {show2 &&
                                    <Col className="" sm={12} lg={6}>
                                        <FormGroup className="mb-3">
                                            <InputGroup className="input-group-alternative" style={{ backgroundColor: ''}}>
                                                <InputGroupAddon addonType="prepend" style={{backgroundColor: ''}}>
                                                    <InputGroupText style={{ backgroundColor: (code2 === 'right' ? 'lightgreen' : 'white'), marginBottom: '0px', color: (code2 === 'right' ? 'black' : '') }}><i className="ni ni-key-25" /></InputGroupText>
                                                </InputGroupAddon>
                                                <Input style={{ backgroundColor: (code2 === 'right' ? 'lightgreen' : 'white'),color: (code2 === 'right' ? 'black' : '#acb5bc')}} value={details.adcode2} placeholder="Super Admin Code" type={showpass4 ? "text" : "password"} name="adcode2" onChange={handleChangeA2} />
                                                <InputGroupAddon addonType="append" style={{ backgroundColor: (code2 === 'right' ? 'lightgreen' : 'white'),marginBottom: '0px' }}>
                                                    <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword4} style={{ color: (code2 === 'right' ? 'black' : '#acb5bc'),padding: '0px 10px',backgroundColor: 'transparent' }} disableRipple>
                                                        {showpass4 ? <Visibility style={{ width: 18 }} /> : <VisibilityOff style={{ width: 18 }} />}
                                                    </IconButton>
                                                </InputGroupAddon>
                                            </InputGroup>
                                        </FormGroup>
                                    </Col>
                                }
                            </Row>
                            <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                                <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                            </Snackbar>
                            <div className="custom-control custom-control-alternative custom-checkbox">
                            </div>
                            <div className="text-center">
                                <Button className="my-0" color="primary" type="button"
                                    onClick={loginPageHandler} disabled={disabling} >
                                    {loading}
                                </Button>
                            </div>
                        </Form>
                    </CardBody>
                </Card>
                <Row className="mt-3">
                    <Col xs="6">
                        <a
                            className="text-light"
                            href="login"
                        >
                            <small>Login</small>
                        </a>
                    </Col>
                    <Col className="text-right" xs="6">
                        <a
                            className="text-light"
                            href="forgot-password"
                        >
                            <small>Forgot password?</small>
                        </a>
                    </Col>
                </Row>
            </Col>
        </>
    );
};

// export default Login;

export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        username: state.userName,
        code: state.code,
    }
}

export default connect(mapStateToProps)(Login);